import { ReactNode, useEffect } from 'react';
import Head from 'next/head';

import Footer from '../Footer/Footer';
import favicon from '../../public/favicon.ico';
import { IntercomPerformanceOptimized } from '../../lib/intercom';
import Header from '@components/Header/Header';
import { useSegment } from '@lib/segment/SegmentContext';

export default function Layout({
  children,
  type,
}: {
  children: ReactNode;
  type: 'businesses' | 'engineers';
}) {
  const segment = useSegment();

  useEffect(() => {
    if (segment.canTrackUser) {
      segment.trackPage({
        category: type,
        name: document.title,
      });
    }
  }, [segment, type]);

  return (
    <>
      <Head>
        <link rel="shortcut icon" href={favicon.src} />
      </Head>
      <Header type={type} hideBanner getStartedLink={undefined} />
      {type == 'engineers' ? <IntercomPerformanceOptimized type={type} /> : <></>}
      {children}
      <Footer type="businesses" />
    </>
  );
}
